export default __webpack_public_path__ + "static/media/coverMobile.74a55773.png";